import { render, staticRenderFns } from "./IconWrapper.vue?vue&type=template&id=53f307f7&"
import script from "./IconWrapper.vue?vue&type=script&lang=js&"
export * from "./IconWrapper.vue?vue&type=script&lang=js&"
import style0 from "./IconWrapper.vue?vue&type=style&index=0&id=53f307f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports